

import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyANFyx-x7mCEldvAHBi6Udlqh-gDdBN9TY",
  authDomain: "masterof-securitysystem.firebaseapp.com",
  projectId: "masterof-securitysystem",
  storageBucket: "masterof-securitysystem.firebasestorage.app",
  messagingSenderId: "1056576062154",
  appId: "1:1056576062154:web:af74223d49e570dc012a33",
  measurementId: "G-3MS82PSTVD"
 
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;